module.exports = "img/flags/GP.b0fe617.png";